import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { ShoppingBag, Menu, X, Search, User } from "lucide-react";
import { useCart } from "../context/CartContext";
import { useAuth } from "../context/AuthContext";

const Navbar = () => {
  const { count, setIsOpen } = useCart();
  const { user } = useAuth();
  const [mobileOpen, setMobileOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const links = [
    { to: "/shop", label: "Shop" },
    { to: "/product/body-butter", label: "Body Butter" },
    { to: "/product/body-oil", label: "Body Oil" },
    { to: "/product/spray-oil", label: "Spray Oil" },
    { to: "/about", label: "About" }
  ];

  return (
    <header className={`sticky top-0 z-40 transition-colors-only ${scrolled ? "bg-charcoal/95 backdrop-blur-md border-b border-off-white/10" : "bg-transparent"}`}>
      <nav className="max-w-[1600px] mx-auto px-6 md:px-10 h-[84px] flex items-center justify-between">
        <div className="flex items-center gap-10">
          <Link to="/" className="flex items-center">
            <img
              src="https://customer-assets-m6fa6gv7.emergentagent.net/job_neon-workshop-3/artifacts/8muchqej_whip_it_up.png"
              alt="Whip it Up"
              className="h-12 md:h-14 w-auto object-contain"
            />
          </Link>
        </div>

        <div className="hidden lg:flex items-center gap-8 absolute left-1/2 -translate-x-1/2">
          {links.map((l, i) => (
            <Link key={i} to={l.to} className="kinetic-link font-serif-display text-[15px] text-off-white hover:text-rose transition-colors-only">
              {l.label}
            </Link>
          ))}
        </div>

        <div className="flex items-center gap-5 md:gap-6">
          <button onClick={() => navigate("/shop")} className="hidden md:flex items-center text-off-white hover:text-rose transition-colors-only" aria-label="Search">
            <Search size={18} strokeWidth={1.5} />
          </button>
          <button
            onClick={() => navigate(user ? "/account" : "/login")}
            className="hidden md:flex items-center text-off-white hover:text-rose transition-colors-only"
            aria-label={user ? "Your account" : "Sign in"}
            data-testid="navbar-account-btn"
            title={user ? user.name || user.email : "Sign in"}
          >
            <User size={18} strokeWidth={1.5} />
          </button>
          <button
            onClick={() => setIsOpen(true)}
            className="relative flex items-center gap-2 text-off-white hover:text-rose transition-colors-only"
            aria-label="Open cart"
          >
            <ShoppingBag size={20} strokeWidth={1.5} />
            {count > 0 && (
              <span className="absolute -top-2 -right-3 bg-off-white text-charcoal text-[10px] font-bold rounded-full h-5 min-w-5 px-1 flex items-center justify-center font-mono">
                {count}
              </span>
            )}
          </button>
          <button className="lg:hidden text-off-white" onClick={() => setMobileOpen(!mobileOpen)}>
            {mobileOpen ? <X size={22} /> : <Menu size={22} />}
          </button>
        </div>
      </nav>

      {mobileOpen && (
        <div className="lg:hidden bg-charcoal border-t border-off-white/10 px-6 py-6 flex flex-col gap-5">
          {links.map((l, i) => (
            <Link key={i} to={l.to} onClick={() => setMobileOpen(false)} className="font-serif-display text-lg text-off-white">
              {l.label}
            </Link>
          ))}
          <Link to={user ? "/account" : "/login"} onClick={() => setMobileOpen(false)} className="font-serif-display text-lg text-rose" data-testid="mobile-account-link">
            {user ? "Your Account" : "Sign in"}
          </Link>
        </div>
      )}
    </header>
  );
};

export default Navbar;
